var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.083 16.333h-.922l-.326-.315a7.584 7.584 0 0 0 1.726-6.23c-.548-3.243-3.255-5.833-6.521-6.23a7.59 7.59 0 0 0-8.482 8.482c.397 3.266 2.987 5.973 6.23 6.521a7.583 7.583 0 0 0 6.23-1.726l.315.326v.922l4.958 4.958c.479.479 1.26.479 1.739 0a1.232 1.232 0 0 0 0-1.738l-4.947-4.97Zm-7 0a5.243 5.243 0 0 1-5.25-5.25 5.243 5.243 0 0 1 5.25-5.25 5.243 5.243 0 0 1 5.25 5.25 5.243 5.243 0 0 1-5.25 5.25Z",
    fill: "currentColor"
  })));
};
export default SvgSearch;